import * as React from 'react'

import classNames from 'classnames/bind'
import range from 'lodash/range'

import { observer } from 'mobx-react'

import type Store from 'modules/calendar/components/TeamView/components/Store'

import styles from './index.module.css'

interface Props {
  store: Store
}
interface DayCellProps {
  store: Store
  day: number
}

const cx = classNames.bind(styles)

const DayCell = observer(function DayCell({ store, day }: DayCellProps) {
  const dayLeaf = store.days[day]
  const cellClassName = cx('dayCell', dayLeaf?.classes)

  return (
    <th className={cellClassName}>
      <div className={styles.content}>{day + 1}</div>
    </th>
  )
})

const TableHeader = observer(function TableHeader({ store }: Props) {
  return (
    <thead>
      <tr>
        <th className={styles.searchCell} />
        {range(store.daysInMonth).map((day) => (
          <DayCell store={store} day={day} key={day} />
        ))}
      </tr>
    </thead>
  )
})

export default TableHeader
